// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Zkjx","content":"styles_content__2PHMq","tableWrap":"styles_tableWrap__1oB73"};